"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectHistory = void 0;
const tslib_1 = require("tslib");
const constants_1 = require("../../../src/constants");
const HistoryStore_1 = require("../constructs/HistoryStore");
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const ModelCommon_1 = require("../ModelCommon");
const uuid_1 = require("uuid");
const constructs_1 = require("../../model/constructs");
class ObjectHistory extends ModelCommon_1.ModelCommon {
    static createForObject(vob, config) {
        const id = (0, uuid_1.v4)();
        const sk = `${ObjectHistory.typeName}_${vob.sk}`;
        let params = {
            type: ObjectHistory.typeName,
            id,
            pk: vob.sk,
            sk,
            name: `${vob.name ?? vob.sk}_History`,
        };
        if (config.recentStateHistory)
            params.recentStateHistory = new HistoryStore_1.HistoryStore(this.getDefaultHistoryObjectParams(constants_1.DataLifeCyclePeriod.DEVICE_PERIOD));
        if (config.dailyStateHistory)
            params.dailyStateHistory = new HistoryStore_1.HistoryStore(this.getDefaultHistoryObjectParams(constants_1.DataLifeCyclePeriod.DAILY));
        if (config.weeklyStateHistory)
            params.weeklyStateHistory = new HistoryStore_1.HistoryStore(this.getDefaultHistoryObjectParams(constants_1.DataLifeCyclePeriod.WEEKLY));
        if (config.monthlyStateHistory)
            params.monthlyStateHistory = new HistoryStore_1.HistoryStore(this.getDefaultHistoryObjectParams(constants_1.DataLifeCyclePeriod.MONTHLY));
        if (config.yearlyStateHistory)
            params.yearlyStateHistory = new HistoryStore_1.HistoryStore(this.getDefaultHistoryObjectParams(constants_1.DataLifeCyclePeriod.YEARLY));
        return new ObjectHistory(params);
    }
    oldconstructor({ recentStateHistory, dailyStateHistory, weeklyStateHistory, monthlyStateHistory, yearlyStateHistory, ...ob }) {
        // super(ob.type ?? ObjectHistory.typeName, ob)
        if (recentStateHistory) {
            this.recentStateHistory = new HistoryStore_1.HistoryStore({ ...ObjectHistory.getDefaultHistoryObjectParams(constants_1.DataLifeCyclePeriod.DEVICE_PERIOD), ...recentStateHistory });
        }
        if (dailyStateHistory) {
            this.dailyStateHistory = new HistoryStore_1.HistoryStore({ ...ObjectHistory.getDefaultHistoryObjectParams(constants_1.DataLifeCyclePeriod.DAILY), ...dailyStateHistory });
        }
        if (weeklyStateHistory) {
            this.weeklyStateHistory = new HistoryStore_1.HistoryStore({ ...ObjectHistory.getDefaultHistoryObjectParams(constants_1.DataLifeCyclePeriod.WEEKLY), ...weeklyStateHistory });
        }
        if (monthlyStateHistory) {
            this.monthlyStateHistory = new HistoryStore_1.HistoryStore({ ...ObjectHistory.getDefaultHistoryObjectParams(constants_1.DataLifeCyclePeriod.MONTHLY), ...monthlyStateHistory });
        }
        if (yearlyStateHistory) {
            this.yearlyStateHistory = new HistoryStore_1.HistoryStore({ ...ObjectHistory.getDefaultHistoryObjectParams(constants_1.DataLifeCyclePeriod.YEARLY), ...yearlyStateHistory });
        }
        if (ob.type) {
            this.type = ob.type;
        }
    }
    constructor({ ...ob }) {
        super(ob.type ?? ObjectHistory.typeName, ob);
        this.type = ObjectHistory.typeName;
        Object.entries(ob)
            .filter(([k, v]) => v && (0, iotv_v3_types_1.isHistoryObject)(v))
            .forEach(([k, v]) => {
            const systemProperties = ObjectHistory.defaultSettings[k];
            this[k] = new HistoryStore_1.HistoryStore(v);
        });
        if (ob.type) {
            this.type = ob.type;
        }
    }
    keys() {
        return Object.entries(this)
            .filter(([k, v]) => v instanceof HistoryStore_1.HistoryStore)
            .map(([k, v]) => k);
    }
    clone(keys = this.keys()) {
        if (keys.length === 0) {
            keys = this.keys();
        }
        const objectHistoryProps = {
            type: this.type,
            sk: this.sk,
            pk: this.pk,
            name: this.name,
            id: this.id,
        };
        if (this.metadata) {
            objectHistoryProps.metadata = this.metadata;
        }
        keys.forEach((k) => (objectHistoryProps[k] = this[k] instanceof HistoryStore_1.HistoryStore ? this[k].clone() : undefined));
        return new ObjectHistory(objectHistoryProps);
    }
    filter(objectHistoryFilter) {
        const filterKeys = Object.keys(objectHistoryFilter);
        const clone = this.clone(filterKeys);
        filterKeys.forEach((k) => {
            if (clone[k] instanceof HistoryStore_1.HistoryStore) {
                clone[k] = clone[k].filter(objectHistoryFilter[k]);
            }
        });
        return clone;
    }
}
exports.ObjectHistory = ObjectHistory;
ObjectHistory.typeName = 'ObjectHistory';
ObjectHistory.defaultReceentHistoryObjectSystemProperties = {
    autoTrim: true,
    maxAgeMS: constants_1.Milliseconds.DAY * 365,
    maxLength: undefined,
};
ObjectHistory.defaultDailyHistoryObjectSystemProperties = {
    autoTrim: true,
    maxAgeMS: constants_1.Milliseconds.DAY * 365 * 5,
    maxLength: undefined,
};
ObjectHistory.defaultWeeklyHistoryObjectSystemProperties = {
    autoTrim: true,
    maxAgeMS: constants_1.Milliseconds.DAY * 365 * 10,
    maxLength: undefined,
};
ObjectHistory.defaultMonthlyHistoryObjectSystemProperties = {
    autoTrim: true,
    maxAgeMS: constants_1.Milliseconds.DAY * 365 * 20,
    maxLength: undefined,
};
ObjectHistory.defaultYearlyHistoryObjectSystemProperties = {
    autoTrim: true,
    maxAgeMS: constants_1.Milliseconds.DAY * 365 * 50,
    maxLength: undefined,
};
ObjectHistory.getDefaultHistoryObjectParams = (period) => {
    let systemProperties;
    switch (period) {
        case constants_1.DataLifeCyclePeriod.DEVICE_PERIOD:
            systemProperties = ObjectHistory.defaultReceentHistoryObjectSystemProperties;
            break;
        case constants_1.DataLifeCyclePeriod.DAILY:
            systemProperties = ObjectHistory.defaultDailyHistoryObjectSystemProperties;
            break;
        case constants_1.DataLifeCyclePeriod.WEEKLY:
            systemProperties = ObjectHistory.defaultWeeklyHistoryObjectSystemProperties;
            break;
        case constants_1.DataLifeCyclePeriod.MONTHLY:
            systemProperties = ObjectHistory.defaultMonthlyHistoryObjectSystemProperties;
            break;
        case constants_1.DataLifeCyclePeriod.YEARLY:
            systemProperties = ObjectHistory.defaultYearlyHistoryObjectSystemProperties;
            break;
        default:
            systemProperties = ObjectHistory.defaultDailyHistoryObjectSystemProperties;
    }
    return {
        index: [],
        timestamp: [],
        systemProperties,
    };
};
ObjectHistory.defaultSettings = {
    recentStateHistory: ObjectHistory.getDefaultHistoryObjectParams(constants_1.DataLifeCyclePeriod.DEVICE_PERIOD),
    dailyStateHistory: ObjectHistory.getDefaultHistoryObjectParams(constants_1.DataLifeCyclePeriod.DAILY),
    weeklyStateHistory: ObjectHistory.getDefaultHistoryObjectParams(constants_1.DataLifeCyclePeriod.WEEKLY),
    monthlyStateHistory: ObjectHistory.getDefaultHistoryObjectParams(constants_1.DataLifeCyclePeriod.MONTHLY),
    yearlyStateHistory: ObjectHistory.getDefaultHistoryObjectParams(constants_1.DataLifeCyclePeriod.YEARLY),
    default: { timestamp: [], index: [] },
};
tslib_1.__decorate([
    (0, constructs_1.enumerable)(false),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", void 0)
], ObjectHistory.prototype, "keys", null);
tslib_1.__decorate([
    (0, constructs_1.enumerable)(false),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Array]),
    tslib_1.__metadata("design:returntype", void 0)
], ObjectHistory.prototype, "clone", null);
tslib_1.__decorate([
    (0, constructs_1.enumerable)(false),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object]),
    tslib_1.__metadata("design:returntype", void 0)
], ObjectHistory.prototype, "filter", null);
